import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { ResType } from "types";
import { exportclientLedger, getClientLedgers } from "api/services/gstr/gstr";
import { useParams } from "react-router-dom";
import Table, { ColumnType } from "components/Table";
import _ from "lodash";
import { getLedgerTypeLabel } from "pages/atom-pro/constants";
import sortHandler from "components/Table/SortHandler";
import { SortDirection } from "data/constants";
import { formattedAmount } from "utils/formattedAmount";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { getIncomeTaxProfile } from "api/services/automation/income-tax";


const ClientLedgers = () => {
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const params = useParams();
  const [sort, setSort] = useState<any>({});

  const { data, isLoading }: ResType = useQuery(
    ["get-gst-client-ledger", params.gstrid, { offset: pageCount * page, limit: pageCount, sort }],
    getClientLedgers,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
    }
  );

  const defaultColumns: Array<ColumnType> = [
    {
      key: "leadgerType",
      title: "Type",
      render: (v) => (
        <Typography>{v?.ledgerType ? getLedgerTypeLabel(v?.ledgerType) : "-"}</Typography>
      ),
    },
    {
      key: "igst",
      title: (
        <Box display="flex" justifyContent='flex-end' width="100%">
          IGST 
        </Box>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (v) => (
        <Typography sx={{ cursor: "pointer", color: "primary.main" }} align="right">{formattedAmount(v?.igst) || "-"}</Typography>
      ),
    },
    {
      key: "cgst",
      title: (
        <Box display="flex" justifyContent='flex-end' width="100%">
          CGST 
        </Box>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (v) => (
        <Typography sx={{ cursor: "pointer", color: "primary.main" }} align="right">{formattedAmount(v?.cgst) || "-"}</Typography>
      ),
    },
    {
      key: "sgst",
      title: (
        <Box display="flex" justifyContent='flex-end' width="100%">
          SGST 
        </Box>
      ),
      render: (v) => (
        <Typography sx={{ cursor: "pointer", color: "primary.main" }} align="right" >{formattedAmount(v?.sgst) || "-"}</Typography>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
    },
    {
      key: "cess",
      title: (
        <Box display="flex" justifyContent='flex-end' width="100%">
          CESS
        </Box>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (v) => (
        <Typography sx={{ cursor: "pointer", color: "primary.main" }} align="right">{formattedAmount(v?.cess) || "-"}</Typography>
      ),
    },

    {
      key: "total",
      title: (
        <Box display="flex" justifyContent='flex-end' width="100%">
          Total 
        </Box>
      ),
      render: (v) => (
        <Typography sx={{ cursor: "pointer", color: "primary.main" }} align="right">{formattedAmount(v?.total) || "-"}</Typography>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
    },
  ];
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));

  const handleSort = (v: any) => {
    sortHandler({
      key: v?.key,
      columns,
      setColumns: setColumns,
      setSortState: setSort,
      sortState: sort,
    });
  };
  console.log(params,"params")
  const { data: profiledata, isLoading: isprofileloading }: ResType = useQuery(
      ["get-income-tax-profile", params.gstrid],
      getIncomeTaxProfile,
    );
  
    const clientName = profiledata?.data?.profileDetails?.name;
    const { mutate: mutate1 } = useMutation(exportclientLedger, {
      onSuccess: (res: any) => {
        const arr = new Uint8Array(res.data?.data);
        const blob = new Blob([arr], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const file = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        const formattedDateTime = getCurrentFormattedDateTime();
        link.href = file;
        link.download = `ATOM Pro - ${clientName} GST Ledgers Balance ${formattedDateTime}.xlsx`;
        link.click();
        snack.success("GST Ledgers Balance exported successfully");
      },
      onError: (err: any) => {
        snack.error(err);
        snack.error(handleError(err));
      },
    });
  
    const handleExport = () => {
      mutate1({
        gstrid: params.gstrid,  
      });
    }
  return (
    <Box p={1}>
       <Box display="flex" justifyContent="flex-end" sx={{ p: 1 }}>
              <Button variant="outlined" color="secondary" onClick={handleExport}
                startIcon={<FileDownloadOutlinedIcon />}>
                Export
              </Button>
            </Box>
      <Table
        sx={{ pb: 0, mb: 0, height: "400px" }}
        pagination={{ totalCount, setPageCount, pageCount, page, setPage }}
        data={data?.data?.result || []}
        columns={columns}
        loading={isLoading}
        sortHandler={handleSort}
      />
    </Box>
  );
};

export default ClientLedgers;
